import React from 'react';

import MissionControlHeadView from './MissionControlHead.view';
import { MSelectChangeData, MSelectOption } from 'views/MSelect/MSelect.model';
import { ConnectorPowerLabel, ConnectorTypeLabel } from 'utils/enums/chargingType';
import { OnChangeValue } from 'react-select';
import { ModuleActions, ModuleCodes } from 'models/modules';
import usePerm from 'utils/hooks/use-perm';

type Props = {
  connectorTypeFilters: MSelectOption<null, ConnectorTypeLabel>[];
  generalFilterValue: string;
  dateFilters: {
    startDate: moment.Moment | null;
    endDate: moment.Moment | null;
  };
  powerTypeFilters: MSelectOption<null, ConnectorPowerLabel>[];
  onConnectorTypeFilterChange: (value: OnChangeValue<MSelectChangeData<null, ConnectorTypeLabel>, true>) => void;
  onGeneralFilterChange: (event: React.ChangeEvent<HTMLInputElement>) => void;
  onResetDate?: () => void;
  onDateFilterChange: (startDate: moment.Moment | null, endDate: moment.Moment | null) => void;
  onClearGeneralFilter: () => void;
  onPowerTypeFilterChange: (value: OnChangeValue<MSelectChangeData<null, ConnectorPowerLabel>, true>) => void;
};

const MissionControlHead: React.FC<Props> = (props: React.PropsWithChildren<Props>) => {
  const perm = usePerm();

  return (
    <MissionControlHeadView
      connectorTypeFilters={props.connectorTypeFilters}
      onConnectorTypeFilterChange={props.onConnectorTypeFilterChange}
      onGeneralFilterChange={props.onGeneralFilterChange}
      generalFilterValue={props.generalFilterValue}
      onResetDate={props.onResetDate}
      dateFilters={props.dateFilters}
      onDateFilterChange={props.onDateFilterChange}
      onClearGeneralFilter={props.onClearGeneralFilter}
      onPowerTypeFilterChange={props.onPowerTypeFilterChange}
      powerTypeFilters={props.powerTypeFilters}
      isBuildScenarioPermitted={!!perm.can(ModuleActions.MissionControl.BuildScenario, ModuleCodes.MissionControl)}
    ></MissionControlHeadView>
  );
};

MissionControlHead.displayName = 'MissionControlHead';
MissionControlHead.defaultProps = {};

export default MissionControlHead;
